import React, { FC, ReactNode } from 'react';
import MuiGrid from '@mui/material/Grid';
import { SxProps, Theme } from '@mui/material';

type GridItemPropsType = { cols: 'auto' | number; children: ReactNode; sx?: SxProps<Theme> | undefined };

export const GridItem: FC<GridItemPropsType> = (props) => {
    return (
        <MuiGrid item xs={props.cols} sx={props.sx}>
            {props.children}
        </MuiGrid>
    );
};

type GridPropsType = { cols?: number; spacing?: number; children: ReactNode; sx?: SxProps<Theme> };

const Grid: FC<GridPropsType> = (props) => (
    <MuiGrid container spacing={props.spacing || 2} columns={{ xs: 1, sm: 1, md: props.cols || 12 }} sx={props.sx}>
        {props.children}
    </MuiGrid>
);

export default Grid;
